import debug from 'bows';
import breakpoints from './_breakpoints';
import PlayworksNearYou from './_playworks-near-you';

const removeStyleAttr = function () {
	this.removeAttribute('style');
	this.removeEventListener('transitionend', removeStyleAttr);
	this.removeEventListener('webkitTransitionEnd', removeStyleAttr);
}

class MobileMenu {
	constructor() {
		this.opened = false;
		this.menuOpenClass = 'menu--open';
		this.togglerOpenClass = 'header__menu-toggle--open';

		this.toggler = document.querySelector('.header__menu-toggle');
		this.toggler.addEventListener('click', (e) => {
			if (document.body.clientWidth < breakpoints.medium) {
				e.preventDefault();
				this.toggle();
			}
		});

		this.menus = document.querySelector('.header__menus');
		this.menuWrapper = document.querySelector('.header__logo');

		window.addEventListener('site.resize', this.resize.bind(this));
	}

	toggle() {
		if (this.opened) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		document.body.classList.add(this.menuOpenClass);
		this.toggler.classList.add(this.togglerOpenClass);
		this.opened = true;
		this.resize();
	}

	close() {
		document.body.classList.remove(this.menuOpenClass);
		this.toggler.classList.remove(this.togglerOpenClass);
		this.menus.addEventListener('transitionend', removeStyleAttr);
		this.menus.addEventListener('webkitTransitionEnd', removeStyleAttr);
		this.menus.style.height = 0;
		this.opened = false;
	}

	resize() {
		if (this.opened) {
			if (document.body.clientWidth < breakpoints.medium) {
				this.menus.style.height = `${document.documentElement.clientHeight - this.menuWrapper.getBoundingClientRect().height}px`;
			} else {
				this.close();
			}
		}
	}
}

class MobileMenuNational extends MobileMenu {
	constructor() {
		super();

		this.log = debug('mobile-menu-national');
		this.menuWrapper = document.querySelector('.header__logo');

		this.menus = document.querySelector('.header__menus');
		this.menu = {
			primary: document.querySelector('.nav--primary'),
			utility: document.querySelector('.nav--utility'),
			wrap: document.querySelector('.header__menus-wrap')
		}

		this.menu.secondary = document.createElement('nav');
		this.menu.secondary.className = 'nav--secondary';
		this.menu.secondary.insertAdjacentHTML('afterbegin', `<p class="nav--secondary-header"><a href="#back" class="nav--secondary-back">Back</a> <a class="nav--secondary-title"></a></p>`);
		this.menu.secondaryTitle = this.menu.secondary.querySelector('.nav--secondary-title');
		this.menu.secondaryBack = this.menu.secondary.querySelector('.nav--secondary-header > a');
		this.menu.secondaryBack.addEventListener('click', (e) => {
			e.preventDefault();
			this.unshow();
		});

		this.menu.primary.parentNode.appendChild(this.menu.secondary);

		this.menu.parents = this.menu.primary.querySelectorAll('.nav__menu-item--depth0.nav__menu-item--has-submenu > .nav__link');

		Array.prototype.slice.call(this.menu.parents).forEach((item) => {
			item.addEventListener('click', (e) => {
				if (document.body.clientWidth < breakpoints.medium) {
					e.preventDefault();
					this.show(item.parentNode);
				}
			});
		});
	}

	close() {
		super.close();
		this.unshow();
	}

	show(parent) {
		this.menu.secondary.insertAdjacentHTML('beforeend', parent.querySelector('.nav__menu--depth1').outerHTML);
		this.menu.secondaryTitle.innerHTML = parent.firstChild.textContent;
		this.menu.secondaryTitle.href = parent.firstChild.href;
		this.menu.wrap.style.transform = 'translateX(-100%)';
		this.menu.primary.style.height = `${this.menu.secondary.getBoundingClientRect().height}px`;

		// re-initialize playworks near you lookup cause cloning html doesn't copy events
		const menuLookup = this.menu.secondary.querySelector('.pny-lookup');
		if (menuLookup) {
			this._nearYouMenu = new PlayworksNearYou.nav(menuLookup);
		}
	}

	unshow() {
		let menu = this.menu.secondary.querySelector('.nav__menu--depth1');
		if (menu) {
			menu.parentNode.removeChild(menu);
		}

		this.menu.wrap.style.transform = 'translateX(0)';
		this.menu.primary.style.height = '';
	}
}

class MobileMenuRegional extends MobileMenu {
	constructor() {
		super();
		this.log = debug('mobile-menu-national');
	}
}

export default {
	regional: MobileMenuRegional,
	national: MobileMenuNational
}
